// SPICePlusFormFiling.jsx
import React from "react";

export default function SPICePlusFormFiling() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            SPICe+ Form Filing
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            SPICe+ Form Filing for Company Incorporation
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides expert assistance in SPICe+ Form
            filing for company incorporation, covering both name reservation and
            integrated registrations like PAN, TAN, DIN and other linked
            services as prescribed under the Companies Act, 2013.[web:296][web:300]
          </p>
          <p className="text-gray-700">
            The focus is on structuring promoter details, capital, objects and
            attachments so that the SPICe+ application meets current MCA portal
            requirements with minimal resubmissions.[web:296][web:297]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/7876291/pexels-photo-7876291.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Professionals reviewing incorporation and MCA forms on a laptop"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-top border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for SPICe+ Filing
            </h2>
            <p className="text-gray-700 mb-4">
              The core SPICe+ documentation revolves around director and
              shareholder KYC, registered office proof, and charter
              documents such as MOA and AOA.[web:296][web:297][web:300]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Director and shareholder KYC, including PAN, identity proof
                  (Aadhaar/passport/voter ID) and recent address proof as per
                  MCA norms.[web:296][web:297]
                </li>
                <li>
                  Registered office proof such as utility bill, ownership
                  document or rent agreement with NOC, generally not older than
                  the period specified by MCA.[web:296][web:302]
                </li>
                <li>
                  MOA and AOA in the prescribed formats, capturing the
                  company&apos;s objects, capital structure and internal
                  governance for attachment with SPICe+ Part B.[web:296][web:300]
                </li>
                <li>
                  Any additional declarations and forms like INC‑9 or consent
                  forms, depending on shareholding, residency and other
                  conditions.[web:296][web:299]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The service is designed to reduce MCA queries and ensure that
              incorporations progress smoothly from draft to Certificate of
              Incorporation.[web:296][web:298]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  MCA Filing Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Up‑to‑date understanding of SPICe+ workflows, linked forms and
                  portal validations helps align applications with current MCA
                  expectations.[web:296][web:300]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Error-Free Documentation
                </h3>
                <p className="text-gray-700 text-sm">
                  Careful drafting and review of names, objects, share capital
                  and attachments reduces the likelihood of resubmissions or
                  rejection.[web:296][web:299]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End‑to‑end guidance from data collection and DSC coordination
                  through upload, fee payment and tracking incorporation
                  status on the MCA portal.[web:297][web:298]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
